module.exports = __webpack_public_path__ + "img/dots_three.090d9f2a.svg";